<template>
  <section>
    <section
      ref="projectSelectRef"
      :class="[
        'project-select-container',
        popperVisible ? 'is-active' : ''
      ]"
      @click="handlePopoverShow"
    >
      <base-svg-icon
        icon-class="icon-address"
        class-name="icon-address"
      />
      <section class="project-name-wrap">
        <p
          :class="[
            'project-name',
            selectCurrentNames?.length === 0 ? 'placeholder' : ''
          ]"
        >
          {{ selectCurrentNames.at(0) || '请选择项目' }}
        </p>
        <el-tag
          v-if="selectCurrentNames.length > 1"
          type="info"
          size="small"
          class="ml-4"
        >
          +{{ selectCurrentNames.length - 1 }}
        </el-tag>
      </section>
      <section class="icon-arrow-wrap">
        <el-icon
          :class="[
            'icon-arrow',
            popperVisible ? 'icon-arrow-up' : 'icon-arrow-down'
          ]"
        >
          <arrow-down />
        </el-icon>
      </section>
    </section>
    <el-popover
      ref="popoverRef"
      :visible="popperVisible"
      trigger="click"
      placement="bottom-start"
      :virtual-ref="projectSelectRef"
      virtual-triggering
      popper-class="the-popover__base-project-multiple-select"
      :disabled="disabled"
      @hide="popoverHideCallback"
    >
      <section
        v-click-outside="handlePopoverHide"
        class="popover-panel-content"
      >
        <el-input
          v-model="filterText"
          placeholder="请输入关键字"
          class="input-with-select"
          clearable
          :prefix-icon="Search"
          @input="handleFilterTextChange"
        />
        <el-tree-v2
          ref="treeRef"
          class="pt-12 pr-12 pb-12 pl-12"
          node-key="orgId"
          :data="orgList"
          :props="{
            children: 'children',
            label: 'name',
            value: 'orgId',
            disabled: 'disabled',
          }"
          highlight-current
          show-checkbox
          :default-checked-keys="[...defaultCheckedkeys]"
          :height="360"
          :filter-method="handleFilterNode"
          @check-change="checkChange"
        />
        <section class="popover-footer-buttons">
          <el-button
            size="small"
            @click="closePopper"
          >
            取消
          </el-button>
          <el-button
            size="small"
            @click="handleClearSelected"
          >
            清空
          </el-button>
          <el-button
            size="small"
            type="primary"
            @click="handleChangeOrg"
          >
            确定
          </el-button>
        </section>
      </section>
    </el-popover>
  </section>
</template>
<script setup lang="ts">
  import {
    computed, ref, watch, nextTick,
  } from 'vue';
  import { ClickOutside as vClickOutside } from 'element-plus';
  import { useAppStore } from '@/store/app';
  import { useOrgStore } from '@/store/org';
  import { debounce } from '@/utils';

  import { ArrowDown, Search } from '@element-plus/icons-vue';
  import { OrgType } from '@/types';

  const appStore = useAppStore();
  const orgStore = useOrgStore();
  const treeRef = ref();
  const projectSelectRef = ref();
  const selectCurrent = ref<string[]>([]);
  const selectCurrentNames = ref<string[]>([]);
  const orgList = computed(() => orgStore.orgList);
  const popperVisible = ref(false);
  const filterText = ref('');

  const emit = defineEmits(['visible-change']);
  const defaultCheckedkeys = ref<string[]>([]);

  defineProps({
    disabled: {
      type: Boolean,
      default: false,
    },
  });

  const handleFilterTextChange = debounce((val) => {
    treeRef.value!.filter(val);
  }, 300);

  const checkChange = () => {
    const checkedNodes = treeRef?.value?.getCheckedNodes(true);
    if (checkedNodes && checkedNodes.length === 0) {
      defaultCheckedkeys.value = [];
    } else {
      defaultCheckedkeys.value = checkedNodes.map((info:any) => info.orgId);
    }
  };

  const handleFilterNode:Func = (value: string, node: OrgType) => {
    if (!value) {
      return node;
    }
    return node.name.includes(value);
  };

  const handlePopoverShow = () => {
    popperVisible.value = true;
  };
  const closePopper = () => {
    selectCurrentNames.value = orgStore.currentOrgInfoList.map((item) => item.name);
    selectCurrent.value = orgStore.currentOrgIds || [];
    defaultCheckedkeys.value = selectCurrent.value;
    popperVisible.value = false;
  };

  const popoverHideCallback = () => {
    emit('visible-change', false);
    filterText.value = '';
    treeRef.value!.filter(filterText.value);
    treeRef?.value?.setCheckedKeys(selectCurrent.value);
    treeRef?.value?.setExpandedKeys(selectCurrent.value);
    closePopper();
  };

  const handlePopoverHide = () => {
    if (!popperVisible.value) {
      return;
    }
    popperVisible.value = false;
  };

  const handleChangeOrg = () => {
    const checkedNodes = treeRef?.value?.getCheckedNodes(true);
    console.log('checkedNodes-multip', checkedNodes);
    if (checkedNodes && checkedNodes.length > 0) {
      orgStore.setCurrentOrgInfoList(checkedNodes, true);
      orgStore.setCurrentOrgInfo(checkedNodes[0], true);
    } else {
      orgStore.setCurrentOrgInfoList([], true);
    }

    nextTick(() => {
      handlePopoverHide();
      /*
       * 刷新页面
       * appStore.setCurrentDate(Date.now());
       */
    });
  };

  const handleClearSelected = () => {
    treeRef.value!.setCheckedKeys([]);
  };
  watch(
    () => orgStore.currentOrgIds,
    () => {
      console.log('orgStore.currentOrgInfoList', orgStore.currentOrgInfoList);
      selectCurrentNames.value = orgStore.currentOrgInfoList.map((item) => item.name);
      selectCurrent.value = orgStore.currentOrgIds || [];
      defaultCheckedkeys.value = selectCurrent.value;
    },
    {
      immediate: true,
      deep: true,
    }
  );

</script>
<style lang="scss">
.the-popover__base-project-multiple-select {
  width: auto !important;
  min-width: 240px !important;
  padding: 0 !important;
}
</style>
<style scoped lang="scss">
.ml-4 {
  margin-left: 4px;
}

.project-select-container {
  --maia-project-select-pl-width: 28px;
  --maia-project-select-pr-width: 30px;

  position: relative;
  display: flex;
  align-items: center;
  box-sizing: border-box;
  width: 260px;
  height: 28px;
  padding-right: 30px;
  padding-left: 28px;
  background-color: transparent;
  border-radius: 2px;
  box-shadow: 0 0 0 1px var(--#{$namespace}-input-border-color, var(--#{$namespace}-border-color)) inset;
  cursor: pointer;

  &.is-active {
    box-shadow: 0 0 0 1px var(--#{$namespace}-input-focus-border-color, var(--#{$namespace}-color-primary)) inset;
  }

  .icon-address {
    position: absolute;
    top: 5px;
    left: 6px;
    z-index: 9;
    color: #fff;
    font-size: 18px;
  }

  .icon-arrow-wrap {
    position: absolute;
    top: 0;
    right: 3px;
    z-index: 9;
    display: flex;
    align-items: center;
    width: 22px;
    height: 28px;
    color: #fff;

    .icon-arrow {
      transition: transform var(--#{$namespace}-transition-duration);

      &.icon-arrow-up {
        transform: rotate(180deg);
      }
    }
  }

  .project-name-wrap {
    display: flex;
    flex: 1;
    align-items: center;
    width: calc(var(--maia-project-select-wrap-width)
    - var(--maia-project-select-pl-width)
    - var(--maia-project-select-pr-width));

    .project-name {
      display: -webkit-box;
      overflow: hidden;
      color: #000;
      text-overflow: ellipsis;
      -webkit-line-clamp: 1;
      -webkit-box-orient: vertical;

      &.placeholder {
        color: var(--#{$namespace}-text-color-placeholder);
      }
    }
  }
}

.input-with-select {
  padding: var(--maia-base-space) var(--maia-base-space) var(--maia-mini-space);
  border-bottom: 1px solid var(--#{$namespace}-border-color);
}

.popover-footer-buttons {
  box-sizing: border-box;
  height: 36px;
  margin-bottom: 12px;
  padding-top: 6px;
  padding-right: 12px;
  line-height: 25px;
  text-align: right;
  border-top: 1px solid var(--#{$namespace}-timepicker-inner-border-color, var(--#{$namespace}-border-color-light));
}
</style>
